import { render } from "./BlWorkflowView.vue?vue&type=template&id=37d9882a&scoped=true"
import script from "./BlWorkflowView.vue?vue&type=script&lang=js"
export * from "./BlWorkflowView.vue?vue&type=script&lang=js"

import "./BlWorkflowView.vue?vue&type=style&index=0&id=37d9882a&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d9882a"]])

export default __exports__